export default "__VITE_ASSET__39f75d42__"